import React from "react";
import withOthersNotSelected from "../../assets/images/svg/withOthersNotSelected.svg";
import nuvamaSelected from "../../assets/images/svg/nuvamaSelected.svg";
import withOtherSelected from "../../assets/images/svg/withOtherSelected.svg";
import nuvamaNotSelected from "../../assets/images/svg/nuvamaNotSelected.svg";

const HoldingSelector = ({
  isHeldaway,
  withNuvama,
  withOthers,
  isSelectionDisabled,
  handleChange,
}) => {
  const styleObj = isHeldaway
    ? { cursor: "pointer" }
    : { cursor: "not-allowed" };

  return (
    <fieldset
      aria-disabled={isSelectionDisabled}
      className="investment-held-with-selector"
    >
      <legend className="legend-heading">Investment Held With Access</legend>

      {/* WITH NUVAMA*/}
      <label className="with_nuvama held-with-button" style={styleObj}>
        <div className="logo2">
          <input
            type="checkbox"
            checked={withNuvama}
            disabled={
              isSelectionDisabled != undefined
                ? isSelectionDisabled
                : !isHeldaway
            }
            aria-disabled={isSelectionDisabled}
            className="checkbox-selector"
            onChange={() => handleChange({ isNuvama: true })}
          />
          <img src={withNuvama ? nuvamaSelected : nuvamaNotSelected} alt="" />
        </div>
        <div className="title2">Nuvama Private</div>
      </label>

      {/* WITH OTHERS */}
      <label className="without_nuvama held-with-button" style={styleObj}>
        <div style={{ cursor: "pointer" }} className="logo3">
          <input
            type="checkbox"
            checked={withOthers}
            disabled={
              isSelectionDisabled != undefined
                ? isSelectionDisabled
                : !isHeldaway
            }
            aria-disabled={isSelectionDisabled}
            className="checkbox-selector"
            onChange={() => handleChange({ isNuvama: false })}
          />
          <img
            src={withOthers ? withOtherSelected : withOthersNotSelected}
            alt=""
          />
        </div>
        <div className="title3">Others</div>
      </label>
    </fieldset>
  );
};

export default HoldingSelector;
